import { Pipe, PipeTransform } from '@angular/core';
import { LangService } from '../services/lang.service';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  constructor(private lang: LangService) {}

  transform(str: string, idLang: number): string {
    return this.lang.translate(str, idLang)
  }

}
